<template>
  <CChartLine :datasets="defaultDatasets" :labels="label" :options="{ maintainAspectRatio: true }" />
</template>

<script>
import { CChartLine } from "@coreui/vue-chartjs";
import DateFo from "../../services/DateFormat";
export default {
  name: "CloudChart",
  props: ["lab"],
  data() {
    return {
      label: [],
      check: []
    };
  },
  components: { CChartLine },
  computed: {
    defaultDatasets() {
      return [
        {
          label: "couverture nuageuse (%)",
          backgroundColor: "#b9a26c",
          data: this.check
        }
      ];
    }
  },
  created() {
    const options = {
      day: "2-digit",
      month: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      hour12: false
    };

    for (var i = 0; i < this.lab.length; i++) {

      const forecast = this.lab[i];


      const date = new Date(forecast.dt_txt);
      const formattedDate = date.toLocaleString("en-GB", options).replace(",", "");
      this.label.push(formattedDate);

    
      this.check.push(forecast.clouds.all);
    }
  }
};
</script>
